import striptags from "striptags";

export function getExcerptFromContent(content?: string | null) {
  if (!content) {
    return "";
  }

  const plainText = striptags(content) || "";
  const trimmed = plainText
    .trim()
    .replace(/(\n| ){2,}/g, " ")
    .substr(0, 160);

  const lastMeaningfulIndex = Math.max(
    trimmed.lastIndexOf("."),
    trimmed.lastIndexOf("!"),
    trimmed.lastIndexOf('"'),
  );

  if (lastMeaningfulIndex === -1) {
    return trimmed;
  }

  return trimmed.substr(0, lastMeaningfulIndex + 1);
}

export function setAmpImgProps(src: string, width?: number, height?: number) {
  const template = `
      <div class='formatted-text__media-amp-img'>
              <amp-img
              layout="fill"
              class='contain'
              src='${src}'
              width='${width}'
              height='${height}'
              style="max-height: 100vh;"
              ></amp-img>
          </div>
          `;
  return template;
}

export function replaceAmpImageTags(content?: string | null) {
  const regexpImg = /src="(.+?)"/g;
  const regexpDataImg = /data-src="(.+?)"/g;
  const regexpDataImgWidth = /\?w=(\d+)|width="(\d+)"/g;
  const regexpDataImgHeight = /\?h=(\d+)|height="(\d+)"/g;

  return content?.replace(/<img[^>]+>/g, function (image) {
    let src = image.match(regexpDataImg)?.pop()?.replace(regexpDataImg, "$1");
    const width =
      image.match(regexpDataImgWidth)?.pop()?.match(/\d+/g)?.map(Number)[0] ||
      100;
    const height =
      image.match(regexpDataImgHeight)?.pop()?.match(/\d+/g)?.map(Number)[0] ||
      100;

    if (!src) {
      src = image.match(regexpImg)?.pop()?.replace(regexpImg, "$1");
    }
    // @amp fix for images
    if (src) {
      src = src.replace(
        process.env.INPUT_SOCIAL_SHARING_URL!,
        process.env.OUTPUT_CDN_IMAGE_URL!,
      );
    }
    return src ? setAmpImgProps(src, width, height) : "";
  });
}

/**
 * Converts image tags with internal CDN urls to the ones compatible with next/image
 */
export function fixInternalCdnSource(content?: string | null) {
  return content?.replace(
    /http:\/\/cdn-internal:8081\/[^ "]+/gi,
    function (src) {
      return `/the-buzz/_next/image?w=1080&q=75&url=${encodeURIComponent(src)}`;
    },
  );
}
